import { Params } from './types'

/**
 * This function converts the search parameter string from window.location to an object
 * @param {string} search The search parameters from window.location
 * @returns An object constant representing the user's role.
 */

export default function (search: string): Params {

  if (typeof search !== 'string' || search.match(/^\?.*?$/) === null) return {}

  return search
    .replace('?', '')
    .split('&')
    .map(entry => entry.split('='))
    .reduce((configObj, [option, value]) => {

      if (option.trim() === '') return configObj

      if (option === 'debug' || option === 'mediaStatsEnabled' || option === 'serviced' || option === 'localBridge') {

        configObj[option] = ['1', 'true'].some(truthyValueTest => truthyValueTest === value)

      }
      else configObj[option] = value

      return configObj

    }, {})

}
